import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useEffect, useMemo} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Checklist} from 'yougile-model'
import {TextArea} from '@components/common/base/textarea'
import {LinkButtonAdd} from '@components/right-panel/checklists-tab/link-button-add'
import {DragControl, dragPropsFromCtl} from '@containers/hooks-draggable'
import {cn} from '@containers/html-utils'
import {useChecklistsStore} from '../../checklists-store'
import {ItemFullId} from '../../types'
import {useChecklistStore} from './checklist-store'

interface Props {
  list: Checklist
  checklistItemDragCtl: DragControl<ItemFullId>
  className?: string
}

const TwContainer = tw.div`
  mb-8
  pl-32
  pr-16
  py-8
  bg-grey-l80
  rounded-4

  cursor-default
  text-xs-regular
  text-primary
  relative
`

export const ChecklistItemAdd = observer(
  ({list, checklistItemDragCtl, className}: Props) => {
    const [state, store] = useChecklistStore()
    const [checklistsState, checklistsStore] = useChecklistsStore()

    useEffect(() => {
      if (checklistsState.newListId === list.id) {
        checklistsStore.setNewListProcessed()
        store.startAddItem()
      }
    }, [])

    const listId = useMemo(() => ({listId: list.id}), [list.id])

    React.useLayoutEffect(() => {
      state.clearAddItemCallback?.()
    }, [list.items.length])

    if (state.addingItem) {
      const id = `add-checklist-item-${list.id}`

      return (
        <TwContainer id={id}>
          <TextArea
            placeholder={Lang.msg.checklistItemPlaceholder}
            onSubmit={api => store.submitAddItem(api, false)}
            onCancel={store.cancelAddItem}
            onChange={store.onChangeAddItem}
            onBlur={api => store.submitAddItem(api, true)}
            autoFocus
            borders={false}
            paddings={'none'}
            noBackground
            textSize="small"
            allowSoftNewLine
          />
        </TwContainer>
      )
    }

    if (!checklistsState.allowChecklists) {
      return null
    }

    return (
      <div className={cn('pb-8', className)}>
        <div {...dragPropsFromCtl(listId, checklistItemDragCtl)}>
          <LinkButtonAdd
            onMouseDown={store.startAddItem}
            text={Lang.msg.addSubtask}
            className="ml-8"
            type={'circle'}
          />
        </div>
      </div>
    )
  }
)
